"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayRotateFunctionTemplate = void 0;
function StringArrayRotateFunctionTemplate() {
    return `
        (function (stringArrayFunction, comparisonValue) {
            const stringArray = stringArrayFunction();
        
            while (true) {
                try {
                    const expression = {comparisonExpressionCode};
                                            
                    if (expression === comparisonValue) {
                        break;
                    } else {
                        stringArray['push'](stringArray['shift']());
                    }
                } catch (e) {
                    stringArray['push'](stringArray['shift']());
                }
            }
        })({stringArrayFunctionName}, {comparisonValue});
    `;
}
exports.StringArrayRotateFunctionTemplate = StringArrayRotateFunctionTemplate;
